import { type ClassName, twx } from '@ctw/shared/utils/tailwind';
import { type PropsWithChildren, forwardRef } from 'react';

export interface SheetProps extends PropsWithChildren {
  id?: string;
  testId?: string;
  className?: ClassName;
  fullbleed?: boolean;
}

export const Sheet = forwardRef<HTMLElement, SheetProps>(
  ({ id, testId, fullbleed, className, children }, ref) => (
    <section
      ref={ref}
      id={id}
      data-testid={testId}
      className={twx(
        'overflow-hidden rounded-lg bg-white shadow-md',
        {
          'px-5 py-6': !fullbleed,
        },
        className,
      )}
    >
      {children}
    </section>
  ),
);
